import { render, staticRenderFns } from "./editor-tool.vue?vue&type=template&id=5f2e9b30&scoped=true&"
import script from "./editor-tool.vue?vue&type=script&lang=js&"
export * from "./editor-tool.vue?vue&type=script&lang=js&"
import style0 from "./editor-tool.vue?vue&type=style&index=0&id=5f2e9b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e9b30",
  null
  
)

export default component.exports